export const backend_url = "https://api.quantviz.com";  // Use the production HTTPS URL
//export const backend_url = "http://192.168.31.86:5001/api/v1";
